// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"02e97beee4b4f3edc595","303":"1634d34a19b0c4228ca3","495":"0b45b3b46d3eecdef649"}[chunkId] + ".js";
};